<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!--页头-->
							<div class="page_header">Training Configuration</div>
							<!--页头-->
							<div class="page_main">
								<div class="btn_el">
									<div class="tips">You can configure training types in the system using the link below.</div>
									<div class="btn">
										<el-button type="text" @click="goUrl('/TrainControl/type-index')">Configure Training Types</el-button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
export default {
	components:{
		headers,
		slider
	},
	data() {
		return {
			isLoading: true,
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//跳转页面
		goUrl(url) {
			let that = this;
			that.$router.push(url);
		},
	}
}
</script>

<style lang="less" scoped>
//主要内容
.main_main{
	.page_main{
		padding: 18px 20px;
		.btn_el{
			margin: 10px 0 20px 0;
			.tips{
				padding: 6px 8px;
				background-color: #ffb1001a;
				border-radius: 6px;
				font-size: 16px;
				font-weight: bold;
			}
		}
	}
	//页头
	.page_header{
		padding: 0 20px;
		height: 60px;
		line-height: 60px;
		background-color: #d8e4f0;
		font-size: 24px;
		font-weight: bold;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
	}
}
</style>
<style scoped>
.main_box{
	height: calc(100vh - 60px);
	overflow-y: auto;
}
.main_box .main_main{
	position: relative;
	min-height: calc(100% - 0px);
	max-height: auto;
	background-color: #FAFAFA;
}
.el-header, .el-main{
	padding: 0;
}
::v-deep .btn span{
	text-decoration: underline;
}
</style>

